export const BOARD_GO_TO_START = 'board-go-to-start';
export const BOARD_PAN_TO = 'board-pan-to-position';
/** Frame the cards after FOKUS changes the set. `detail.tasks` and `detail.positions`. */
export const BOARD_FRAME = 'board-frame';

/** Run after the browser has painted, so a camera move is visible before a heavy re-render. */
export function afterNextPaint(fn) {
  requestAnimationFrame(() => {
    requestAnimationFrame(fn);
  });
}
